import { __exports as formatter } from './_virtual-formatter.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireDefineProperty } from './node_modules-@babel-runtime-helpers-defineProperty.js';
import { __require as requireIntlBrowser } from './vp-js-token-engine-build-infrastructure-intl-browser.js';

var hasRequiredFormatter;

function requireFormatter () {
	if (hasRequiredFormatter) return formatter;
	hasRequiredFormatter = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(formatter, "__esModule", {
	  value: true
	});
	formatter.FormatterService = void 0;
	var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
	var _intlNode = _interopRequireDefault(requireIntlBrowser());
	class FormatterService {
	  constructor() {
	    (0, _defineProperty2.default)(this, "intl", void 0);
	    this.intl = (0, _intlNode.default)();
	  }
	  formatPrice(presentablePrice) {
	    const formatter = new this.intl.NumberFormat(presentablePrice.culture, {
	      currency: presentablePrice.currency,
	      minimumFractionDigits: presentablePrice.minimumFractionDigits,
	      style: 'currency'
	    });
	    return formatter.format(presentablePrice.price);
	  }
	  formatPercentage(value, culture) {
	    const percentFormatter = new this.intl.NumberFormat(culture, {
	      style: 'percent',
	      maximumFractionDigits: 0
	    });
	    return percentFormatter.format(value / 100);
	  }
	  formatPriceDifference(presentablePrice) {
	    const formatter = new this.intl.NumberFormat(presentablePrice.culture, {
	      currency: presentablePrice.currency,
	      minimumFractionDigits: presentablePrice.minimumFractionDigits,
	      style: 'currency'
	    });
	    const sign = presentablePrice.price < 0 ? '' : '+';
	    return "".concat(sign).concat(formatter.format(presentablePrice.price));
	  }
	  formatQuantity(value, culture) {
	    const formatter = new this.intl.NumberFormat(culture, {});
	    return formatter.format(value);
	  }
	}
	formatter.FormatterService = FormatterService;
	
	return formatter;
}

export { requireFormatter as __require };
//# sourceMappingURL=vp-js-token-engine-build-services-formatter.js.map
